fx.ns("shared.extractors", class PhotoExtractor extends shared.MediaExtractor {

    constructor(data)
    {
        super(data);
    }

    processStarting()
    {
        super.processStarting();

        this.data.photos.extracting = true;

        this.trigger("photo-extracted-started");
    }

    processFinished()
    {
        super.processFinished();

        this.data.photos.extracting = false;

        this.trigger("photo-extracted-finished");
    }

    onImageExtracted(data)
    {
        let date = new Date();
        let dateTaken = ( data.date || date )

        let photo = new models.Photo({
            creation_id : this.data.creation ? this.data.creation.id : 0,
            accountid : this.data.creation ? this.data.creation.accountid : 0,
            thumb : data.thumb,
            light_url : data.blob,
            width : data.width,
            height : data.height,
            orientation : data.orientation,
            latitude: data.latitude,
            longitude: data.longitude,
            date_SQL : date.toSQL(),
            date_unix : date.getUnixTime(),
            date_taken_unix : dateTaken.getUnixTime(),
            date_takenSQL : dateTaken.toSQL(),
            number : 0,
            guestid : (fx.get("app") == "uploader") ? this.data.upload.guestid : null,
            deleted : 0,
            average_color : data.luminance,
            validated : (fx.get("app") == "uploader") ? 0 : 1,
            docid : (fx.get("app") == "uploader") ? this.data.eventid : null,
            labels : (fx.get("app") == "uploader") ? this.data.upload.label : ""
        });

        photo.prop("date", photo.date_SQL); // SortPhotosAdded uses it 
        photo.prop("thumbWidth", data.thumbWidth);
        photo.prop("thumbHeight", data.thumbHeight);
        photo.prop("base64", data.thumb);
        photo.prop("date_taken",  data.date || date );
        photo.prop("file", data.file); 
        //photo.prop("memory", data.image); 
        photo.prop("blob", data.blob); 
        
        this.data.photos.addItem( photo );

        this.trigger("photo-extracted", photo);
    }
   
});